/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const containerStyle = css`
  margin-top: 80px;
  text-align: center;
  margin-bottom: 12px;
`;
const titleStyle = css`
  font-weight: 700;
  font-size: 18px;
`;

export const FilterNoResults = () => {
  return (
    <div css={containerStyle} data-pa11y-id="pa11y-runlog-body">
      <p css={titleStyle}>No results meet filter criteria</p>
      <p>Please expand or clear your filters to view more results.</p>
    </div>
  );
};
